import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Container, Row, Col, Alert} from 'react-bootstrap';
export default class InfoBlock extends Component {
  render() { 
    console.log(this.props)
    return (
      <div>
          {this.props.data.map( (text, index) => {
              return <Alert key={index} variant={this.props.variant}>
                {text}
            </Alert>
          })}
      </div>
    );
  }
}

InfoBlock.propTypes = {
  variant: PropTypes.string,
  data: PropTypes.array,

}
